import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

const Goalsyeppy = () => {
  return (
    <div className="goals_yeppy p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <h2>Objectives and Goals</h2>
          </Col>
        </Row>

        <Row className="padd_top">
          <Col xs={12} md={6} lg={3} xl={3} xxl={3}>
            <div className="goals_box_yeppy">
              <div className="goals_box_img">
                <StaticImage
                  src="../../../images/case-studies/yeppy/1.png"
                  alt="TekRevol"
                  className="img-fluid logo_img"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["png"]}
                  width={49}
                />
              </div>
              <div className="goals_img_content">
                <p>
                  The primary objective is to create <span>Yeppy</span> as a
                  comprehensive super app offering Financial, Booking, Retail,
                  and Exclusive services
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={3} xl={3} xxl={3}>
            <div className="goals_box_2">
              <div className="goals_box_2_img">
                <StaticImage
                  src="../../../images/case-studies/yeppy/goals_img.png"
                  alt="TekRevol"
                  className="img-fluid logo_img"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["png"]}
                  width={359}
                />
              </div>
              <div className="goals_2_content">
                <p>
                  The goal is to streamline user experiences, making it more
                  convenient and efficient to perform daily tasks through a
                  single platform.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={3} xl={3} xxl={3}>
            <div className="goals_img_3">
              <StaticImage
                src="../../../images/case-studies/yeppy/calender.png"
                alt="TekRevol"
                className="img-fluid logo_img"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={307}
              />
            </div>
            <div className="goals_box_yeppy">
              <div className="goals_box_img">
                <StaticImage
                  src="../../../images/case-studies/yeppy/3.png"
                  alt="TekRevol"
                  className="img-fluid logo_img"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["png"]}
                  width={49}
                />
              </div>
              <div className="goals_img_content">
                <p>
                  <span>Yeppy</span> aims to drive user engagement, retention,
                  and satisfaction, becoming a one-stop solution for a wide
                  range of daily needs.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={3} xl={3} xxl={3}>
            <div className="goals_img_4">
              <StaticImage
                src="../../../images/case-studies/yeppy/goals_mob.png"
                alt="TekRevol"
                className="img-fluid logo_img"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={329}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Goalsyeppy;
